import { NgModule } from '@angular/core';
import { RequestListComponent } from './request-list.component'
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  exports: [RequestListComponent],
  declarations: [RequestListComponent],
  imports: [
    CommonModule,
    NgxPaginationModule,
    MatTableModule,
    MatIconModule
  ]
})
export class RequestListModule {}
